export default {
  alert: {
    error: 'Favor prencher os campos corretamente!',
    delete: 'tem certeza que deseja deletar esse campo?'
  },
  title: {
    consult: 'Consulta de ',
    include: 'Inclusão de ',
    edit: 'Edição de ',
    delete: 'Deleção de '
  },
  field: {
    select: 'Selecione um(a) '
  },
  button: {
    add: {title: 'Adicionar', icon: 'add'},
    import: {title: 'Importar', icon: 'system_update_alt'},
    manage: {title: 'Gerenciar', icon: 'build'},
    save: {title: 'Salvar', icon: 'save'},
    save_new: {title: 'Salvar e Novo', icon: 'add'},
    save_manage: {title: 'Salvar e Gerenciar', icon: 'build'},
    edit: {title: 'Editar', icon: 'edit'},
    delete: {title: 'Deletar', icon: 'delete'},
    home: {title: 'Página Inicial', icon: 'home'},
    done: {title: 'Confirmar', icon: 'done'},
    exit: {title: 'Sair', icon: 'exit'},
    close: {title: 'Fechar', icon: 'close'}
  },
  table: {
    action: 'Ações',
    decimal: `,`,
    emptyTable: `Nenhum registro encontrado`,
    info: `Exibindo do _START_ ao _END_ de _TOTAL_ registros`,
    infoEmpty: `Exibindo do 0 ao 0 de 0 registros`,
    infoFiltered: `(Filtrado a partir de _MAX_ registros)`,
    infoPostFix: ``,
    thousands: `.`,
    lengthMenu: `Exibir _MENU_ registros`,
    loadingRecords: `Carregando...`,
    processing: `Processando...`,
    search: `Pesquisar`,
    zeroRecords: `Nenhum registro encontrado`,
    paginate: {
      first: `Primeiro`,
      last: `Último`,
      next: `Próximo`,
      previous: `Anterior`
    }
  }
}



// WEBPACK FOOTER //
// ./src/translate/pt_br/system.js